import "./form-member.scss";
import { useFormContext } from "react-hook-form";
import { MemberFormSchema } from "@factory/form/form.rule";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import ImageControl from "@shared/ui/hook-form/image-control/image-control";
import { Divider } from "primereact/divider";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { sexOptions } from "@shared/data/sex";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";

export interface FormMemberProps {
  isChild?: boolean;
  showChildField?: boolean;
}

type InputFormSchema = MemberFormSchema;
export function FormMember({
  isChild,
  showChildField = false,
}: FormMemberProps) {
  const { control } = useFormContext<MemberFormSchema>();

  return (
    <div id="FormMember" className="member w-full">
      <div className="flex flex-col md:flex-row gap-6 w-full">
        <div className="flex flex-col items-start shrink-0">
          <ImageControl<InputFormSchema>
            control={control}
            name="photo"
            label={isChild ? undefined : "Person Photo"}
            imagePreviewClass="w-32 h-32"
            isCircular={isChild}
            instruction={isChild ? "Upload photo" : undefined}
          />
        </div>

        <div className="flex-grow w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
            <InputControl<InputFormSchema>
              control={control}
              name="firstName"
              label="First Name"
              className="w-full"
              containerClassName="w-full"
              placeholder="Enter firstName"
            />
            <InputControl<InputFormSchema>
              control={control}
              name="lastName"
              label="Last Name"
              className="w-full"
              containerClassName="w-full"
              placeholder="Enter lastName"
            />

            {isChild ? (
              <>
                <div className="w-full">
                  <DropdownControl<InputFormSchema>
                    control={control}
                    name="gender"
                    label="Gender"
                    className="w-full"
                    options={sexOptions}
                  />
                </div>
                <InputDigitControl<InputFormSchema>
                  control={control}
                  name="age"
                  label="Age"
                  className="w-full"
                  containerClassName="w-full"
                  placeholder="Enter age"
                />
              </>
            ) : null}

            {!isChild ? (
              <>
                <InputControl<InputFormSchema>
                  control={control}
                  name="mobileNumber"
                  label="Mobile Number"
                  className="w-full"
                  containerClassName="w-full"
                  placeholder="Enter mobileNumber"
                />
              </>
            ) : null}

            {showChildField ? (
              <div className="md:col-span-2">
                <CheckboxControl control={control} name="isChild" label="Is Child" />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* <section className="hidden">
      
        <InputDateControl<InputFormSchema>
          control={control}
          name="birthday"
          label="Birthday"
          className="w-full md:w-3/4"
          containerClassName="pb-2 mt-4"
          placeholder="Enter birthday"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="middleName"
          label="Middle Name"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter middleName"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="emergencyContact_1Number"
          label="Emergency Contact 1 Number"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter emergencyContact_1Number"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="emergencyContact_1Name"
          label="Emergency Contact 1 Name"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter emergencyContact_1Name"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="emergencyContact_1Relationship"
          label="Emergency Contact 1 Relationship"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter emergencyContact_1Relationship"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="emergencyContact_2Number"
          label="Emergency Contact 2 Number"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter emergencyContact_2Number"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="emergencyContact_2Name"
          label="Emergency Contact 2 Name"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter emergencyContact_2Name"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="emergencyContact_2Relationship"
          label="Emergency Contact 2 Relationship"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter emergencyContact_2Relationship"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="streetName"
          label="Street Name"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter streetName"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="subdivision"
          label="Subdivision"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter subdivision"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="zone"
          label="Zone"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter zone"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="sitio"
          label="Sitio"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter sitio"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="purok"
          label="Purok"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter purok"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="barangay"
          label="Barangay"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter barangay"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="municipality"
          label="Municipality"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter municipality"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="province"
          label="Province"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter province"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="region"
          label="Region"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter region"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="country"
          label="Country"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter country"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="zip"
          label="Zip"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter zip"
        />
        <InputDigitControl<InputFormSchema>
          control={control}
          name="longitude"
          label="Longitude"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter longitude"
        />
        <InputDigitControl<InputFormSchema>
          control={control}
          name="latitude"
          label="Latitude"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter latitude"
        />
      </section> */}
    </div>
  );
}

export default FormMember;
